import React from 'react'
import VerifiedIcon from '@mui/icons-material/Verified';
function TipogramVerfied() {
  return (
    <>
       <VerifiedIcon className='featuredArtistsBadgeIcon featuredArtistsVerified'/>
    </>
  )
}

export default TipogramVerfied